import { Flex, Text, UnstyledButton } from '@mantine/core';
import { IconChevronLeft } from '@tabler/icons-react';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';

type Props = {
  onClick: () => void;
  disabled?: boolean;
};

export function CtaAdditionalAI({ onClick, disabled }: Props) {
  return (
    <UnstyledButton
      onClick={onClick}
      disabled={disabled}
      style={{
        position: 'absolute',
        top: 32,
        left: '50%',
        transform: 'translateX(-50%)',
        height: 32,
        paddingLeft: 'var(--mantine-spacing-xs)',
        paddingRight: 'var(--mantine-spacing-sm)',
        backgroundColor: 'var(--mantine-color-orange-2)',
        borderRadius: 'var(--mantine-radius-xl)',
        zIndex: 10,
        whiteSpace: 'nowrap',
        opacity: disabled ? 0.5 : 1,
        transition: 'opacity 0.2s ease-in-out',
      }}
    >
      <Flex align="center" gap="xxxs" h="100%">
        <IconChevronLeft size={16} color="var(--mantine-color-orange-6)" />
        <Text size="textSm" fw={FONT_WEIGHTS.bold} c="orange.6">
          Back to Action Mode
        </Text>
      </Flex>
    </UnstyledButton>
  );
}
